import { render, staticRenderFns } from "./client-details-ip.vue?vue&type=template&id=379eaaa2&scoped=true"
import script from "./client-details-ip.vue?vue&type=script&lang=js"
export * from "./client-details-ip.vue?vue&type=script&lang=js"
import style0 from "./client-details-ip.vue?vue&type=style&index=0&id=379eaaa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379eaaa2",
  null
  
)

export default component.exports